var React = require('react');

function Market (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.49,8.07v4H8.88V1L2.16,4.53V16.38H15.84V8.07Zm-4,.81h-2V5.77h2Zm7.67,4.35h-2v-3.1h2Z"}));
}

Market.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 18 18"};

module.exports = Market;

Market.default = Market;
